<template>
  <div class="modal-questions__list question-sample__list">
    <div
      v-for="(item, index) of questionsSample"
      :key="index"
      class="item"
      :class="{'item--choosed': questionsIdChoose.includes(item.questionId)}"
    >
      <div class="item__head display-table-full">
        <b class="display-inline float-left">{{ item.title }}</b>
        <span v-if="item.title " class="display-inline float-left">:</span>
        <div class="item__head__content display-inline float-left" v-html="item.content"></div>
        <div v-if="item.imageUrl" class="item__head__img text-center margin-center">
					<img 
						:src="`${urlQuestionImg}/${item.imageUrl}`" 
						alt="Ảnh câu hỏi" 
					/>
        </div>
      </div>
      <div class="item__body">
        <div class="answers" v-if="item.type !== questionDownAnswer">
          <div v-for="(ans, pos) of item.answers" :key="pos" class="item__answer">
            <div v-if="ans.imageUrl" class="item__answer__img text-center margin-center">
              <img 
                :src="`${urlQuestionImg}/${ans.imageUrl}`" 
                alt="Ảnh câu hỏi" 
              />
            </div>
            <b>{{ ans.title }}</b><span v-if="ans.title">.</span><div v-html="ans.content"></div>
          </div>
        </div>
      </div>
      <div class="item__footer full-width">
        <div v-if="questionsIdChoose.includes(item.questionId)" class="item__choosed display-flex-center full-width">
          <div class="item__choosed__icon display-flex-center">
            <img width="20" :src="doneIcon" alt="Đã chọn" class="icon-choosed">
            <span class="font-sanpro-semibold secondary-color-txt font-size-16">Đã chọn</span>
          </div>
          <a href="javascript:;" class="item__cancle primary-color font-sanpro-semibold" @click="handleCancleChooseQuestion(item.questionId)">
            Hủy
          </a>
        </div>
        <div v-else class="item__choose display-flex-cemter" @click="handleChooseQuestion(item)">
          <!-- <span class="item__choose__round"></span> -->
          <label class="custom-checkbox">
            <label class="font-sanpro-semibold primary-color font-size-16 cursor-pointer">Chọn</label>
            <input type="checkbox">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <p v-if="!questionsSample || questionsSample.length === 0" class="font-size-18 font-sanpro-semibold secondary-color-txt text-center">
      Không có câu hỏi nào
    </p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import { APP_CONFIG } from '@/utils/constants'
import { TYPE_RADIO, TYPE_DOWN_ANSWER } from '@/modules/question/preview-question/_store/constants'

const doneIcon = require('@/assets/images/linktypes/done.svg')

export default {
  name: 'ModalQuestionSampleList',
  data () {
    return {
      urlQuestionImg: APP_CONFIG.urlQuestionImg,
      appUrl: APP_CONFIG.appUrl,
      questionRadio: TYPE_RADIO,
      questionDownAnswer: TYPE_DOWN_ANSWER,
      doneIcon
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['questionsSample', 'questionsChoose', 'questionsIdChoose'])
  },
  beforeDestroy () {
    this.acSetQuestionSample([])
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetQuestionsChoosed', 'acSetQuestionsIdChoosed', 'acSetQuestionSample']),

    handleChooseQuestion (data) {
      this.questionsChoose.push(data)
      this.questionsIdChoose.push(data.questionId)
      this.acSetQuestionsChoosed([...this.questionsChoose])
      this.acSetQuestionsIdChoosed([...this.questionsIdChoose])
    },

    handleCancleChooseQuestion (id) {
      let indexQuestionChoose = this.questionsIdChoose.findIndex(ques => ques === id)
      if (indexQuestionChoose > -1) {
        this.questionsChoose.splice(indexQuestionChoose, 1)
        this.questionsIdChoose.splice(indexQuestionChoose, 1)
        this.acSetQuestionsChoosed([...this.questionsChoose])
        this.acSetQuestionsIdChoosed([...this.questionsIdChoose])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item__cancle{
  margin-left: 15px;
}
.icon-choosed{
  margin-right: 5px;
}
.item__choose{
  // margin-bottom: 35px;
}
/* The custom-checkbox */
.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  
}

/* Hide the browser's default checkbox */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 10px;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 50%;
  border:1px solid #879AA9;
}

/* On mouse-over, add a grey background color */
.custom-checkbox:hover input ~ .checkmark {
  background-color: #fff;
  
}

/* When the checkbox is checked, add a blue background */
.custom-checkbox input:checked ~ .checkmark {
  background-color: #38c172;
  border:1px solid #38c172;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.custom-checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.modal-questions__list {
  margin-top: 15px;
}
.item {
  margin-bottom: 35px;
  border-radius: 4px;

  &--choosed {
    background: $color_bg_gray_light;
    padding: 10px;
  }
}
</style>